var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-footer"},[_c('span',{staticClass:"footer-text",staticStyle:{"margin-right":"5px"}},[_vm._v("© "+_vm._s(_vm.currentYear)+" Putra Muda Mandiri. MPOS Cashier\n    "+_vm._s(_vm.appVersion))])])
}
var staticRenderFns = []

export { render, staticRenderFns }